export default __webpack_public_path__ + "static/ParallaxBG2-50dfd0c37855229577f47e46fb1ecd01.png";